export const CHECKOUT = "checkout"
export const SHIPPING = "shipping"
export const STANDARD = "standard"
export const NAVIGATION = "navigation"
export const SAVE_AND_CONTINUE = "save & continue"
export const CONTINUE = "continue"
export const LANDING = "landing page"
export const CALL_SUPPORT_PHONE_NUMBER = "call support number"
export const HELP_SUPPORT = "help support"
export const CUSTOMER_SUPPORT = "customer support"
export const ORDER_SUMMARY = "order summary"
export const EDIT_CART = "edit cart"
export const LOAD_MORE = "load more"
export const PRODUCT_NAVIGATION = "product navigation"
export const PROMO = "promo"
export const PAYMENT_BILLING = "payment & billing"
export const CREDIT_CARD = "credit card"
export const REVIEW = "review"
export const CHECKOUT_WITH = "checkout with"
export const CHECKOUT_PROCESS_BUTTON = "process"
export const CHECKOUT_PCIPAL = "pci pal"
export const TERMS_OF_USE = "terms of use"
export const PRIVACY_POLICY = "privacy policy"
export const CHECKOUT_WITH_PAYPAL = "checkout with paypal"
export const PAYPAL = "paypal"
export const PAYMENTS = "payments"
export const CREATE_A_QUICK_ACCOUNT = "create a quick account"
export const FORGOT_PASSWORD = "forgot password"
export const PASSWORD_RESET = "reset your password"
export const NEXT = "next"
export const HOMEOWNER_ACCOUNT = "homeowner account"
export const PROFESSIONAL_ACCOUNT = "professional account"
export const SAVE_CHANGES = "save changes"
export const VERIFY_ADDRESS = "verify address"
export const BILLING_INFORMATION = "billing information"
export const PLACE_ORDER = "place order"
export const PAYMENT_METHOD = "payment method"
export const EXPAND = "expand"
export const COLLAPSE = "collapse"
export const SIGN_IN = "sign in"
export const MOUSE_OVER = "mouseover"
export const SHOW_PASSWORD = "show password"
export const HIDE_PASSWORD = "hide password"
export const CITY_DROPDOWN = "city dropdown selection"
export const PROFESSIONAL = "professional"
export const SELECT_BUSINESS_TYPE = "select business type"
export const SAVE_ADDRESS_TO_MY_ACCOUNT = "save address to my account"
export const CHECKBOX = "checkbox"
export const SIGN_ME_UP_FOR_THE_E_NEWSLETTER = "sign me up for the e-newsletter"
export const SHIPPING_RESTRICTIONS = "shipping restrictions"
export const SUBMIT = "submit"
export const RESEND_EMAIL = "resend email"
export const PAYPAL_ERROR = "paypal error"
export const CART_LABEL = "cart"
export const NOT_APPLICABLE = "not applicable"
export const CONTACT_INFO = "contact information"
export const GUEST_CHECKOUT = "guest checkout"
export const CHECKOUT_AS_GUEST = "checkout as guest"
export const SUCCESS = "success"
export const CHECKOUT_WITH_ACCOUNT = "checkout with account"
export const ACCOUNT = "account"
export const EDIT = "edit"
export const INITIATED = "initiated"
export const CREATE_ACCOUNT = "create account"
export const DELIVERY_ADDRESS = "delivery address"
export const CONTINUE_TO_SHIPPING_METHOD = "continue to shipping method"
export const FAILURE = "failure"
export const EDIT_SHIPPING_ADDRESS = "edit shipping address"
export const ADD_NEW_DELIVERY_ADDRESS = "add a new delivery address"
export const CANCEL = "cancel"
export const SHIPPING_METHOD = "shipping method"
export const VIEW_ITEM_INCLUDED = "view item included"
export const CONTINUE_TO_PAYMENT = "continue to payment"
export const CONTINUE_TO_PAYMENT_SUCCESS = "continue to payment success"
export const CONTINUE_TO_PAYMENT_FAILURE = "continue to payment failure"
export const CHECKOUT_WITH_AFFIRM = "checkout with affirm"
export const AFFIRM = "affirm"
export const PAY_OVER_TIME_WITH_AFFIRM = "affirm pay over time"
export const LEARN_MORE = "learn more"
export const CHECKOUT_WITH_CREDIT_CARD = "checkout with credit card"
export const CREDIT_CARD_ERROR = "credit card input error"
export const SEE_IF_YOU_QUALIFY = "see if you qualify"
export const PREQUALIFY_TOOLTIP = "prequalify now"
export const PAYMENT = "payment"
export const CONTINUE_TO_DELIVERY_ADDRESS = "continue to delivery address"
export const CONTINUE_TO_BILLING_ADDRESS = "continue to billing address"
export const DISPLAYED = "displayed"
export const PAYPAL_EXPRESS_CHECKOUT = "paypal express checkout"
